import {
  FilterListOutlined,
  HelpOutlineOutlined,
  MessageOutlined,
  StorefrontOutlined,
  UploadFileOutlined,
} from '@mui/icons-material';
import { Divider, List, ListItemIcon, ListItemText } from '@mui/material';
import { Permission } from '@procureai/permissions';
import { Restricted } from '@procureai/permissions-ui';
import { NavCollapse, NavDrawerProps, NavSubListItem } from '@procureai/ui-mui';
import { Trans } from 'react-i18next';
import { Link, useMatch } from 'react-router-dom';

import { IntakeDomainType, NavId, QueryParam } from '~/common/types';
import { FiltersNavList } from '~/components/FiltersNavList/FiltersNavList';
import { NavDrawerSimple } from '~/components/NavDrawerSimple/NavDrawerSimple';
import { useLocationSearchParams } from '~/hooks';
import { RouteId } from '~/routes/RouteId';

export const IntakeListDrawer = (props: NavDrawerProps) => {
  const [{ [QueryParam.QUERY]: queryId }] = useLocationSearchParams();
  const isCreateButtonSelected = !!useMatch({ path: RouteId.intakeCreate, end: true }) && queryId === undefined;

  return (
    <NavDrawerSimple navId={NavId.intake} {...props}>
      <List disablePadding sx={{ marginBottom: 4 }}>
        <NavSubListItem component={Link} to={RouteId.intake} selected={!!useMatch({ path: RouteId.intake, end: true })}>
          <ListItemIcon>
            <MessageOutlined />
          </ListItemIcon>
          <ListItemText primary={<Trans i18nKey={`Nav.${NavId.intakeAllRequests}`} />} />
        </NavSubListItem>
      </List>
      <Divider />
      <NavCollapse
        in={true}
        icon={<FilterListOutlined />}
        label={<Trans i18nKey="FilterSelect.label" />}
        sx={{ marginBottom: 4 }}
      >
        <List>
          <FiltersNavList domain={IntakeDomainType.INTAKE} showDot />
        </List>
      </NavCollapse>

      <Divider />
      <NavCollapse in label={<Trans i18nKey={`Nav.${NavId.intakeNewRequest}`} />} sx={{ marginBottom: 4 }}>
        <List>
          <Restricted needs={{ permission: Permission.IntakeCreate }}>
            <NavSubListItem component={Link} to={RouteId.intakeCreate} selected={isCreateButtonSelected}>
              <ListItemIcon>
                <UploadFileOutlined />
              </ListItemIcon>
              <ListItemText primary={<Trans i18nKey="Nav.intakeNewRequest" />} />
            </NavSubListItem>
          </Restricted>
          <Restricted needs={{ permission: Permission.IntakeCreateDemo }}>
            <NavSubListItem component={Link} to={RouteId.intakeChatCreate}>
              <ListItemIcon>
                <StorefrontOutlined />
              </ListItemIcon>
              <ListItemText primary={<Trans i18nKey="Nav.intakeChat" />} />
            </NavSubListItem>
          </Restricted>
          <Restricted needs={{ permission: Permission.IntakeCreateDemo }}>
            <NavSubListItem component={Link}>
              <ListItemIcon>
                <StorefrontOutlined />
              </ListItemIcon>
              <ListItemText primary={<Trans i18nKey="Nav.intakeMarktingService" />} />
            </NavSubListItem>
          </Restricted>
          <Restricted needs={{ permission: Permission.IntakeCreateDemo }}>
            <NavSubListItem component={Link}>
              <ListItemIcon>
                <HelpOutlineOutlined />
              </ListItemIcon>
              <ListItemText primary={<Trans i18nKey="Nav.intakeAskQuestion" />} />
            </NavSubListItem>
          </Restricted>
        </List>
      </NavCollapse>
    </NavDrawerSimple>
  );
};
